import { Box, Stack, Typography } from '@mui/material'
import { FlagIcon } from '@heroicons/react/24/outline'

import { INTERAX_COLORS } from '../../../../../constants/colors'
import { useTranslation } from '../../../../../shared/hooks/useIntractionTranslate'
import { useCoachStatus, useUserGoals } from '../../../../../apiLayer/queryHooks/coach'
import { useIsCoachEnabled } from '../../../../../shared/hooks/useIsCoachEnabled'
import { GamerFeedbackContainerBox } from '../../../../feedbackGenerator/components/GamerFeedbackContainerBox'
import { GOAL_SOURCE_KEY } from '../coachPageStyles'

/**
 * Development goals on the profile page. Renders nothing while either query is still loading, so the
 * card does not flash in and out for users whose org has the coach turned off. It wears
 * `GamerFeedbackContainerBox` so it matches the development-plan sections it sits between.
 */
export const ProfileGoalsCard = () => {
  const { t } = useTranslation()
  const { isLoading: isStatusLoading } = useCoachStatus()
  const isCoachEnabled = useIsCoachEnabled()
  const { data: goals, isLoading: areGoalsLoading } = useUserGoals()

  if (isStatusLoading || areGoalsLoading) return null
  if (!isCoachEnabled || !goals || goals.length === 0) return null

  return (
    <GamerFeedbackContainerBox variant="team" sx={{ width: '100%', alignItems: 'stretch', gap: '16px' }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <FlagIcon width={20} color={INTERAX_COLORS.sun} />
        <Typography sx={{ color: INTERAX_COLORS.white, fontWeight: 700 }}>
          {t('gamer.ariaCoach.myDevelopmentGoals')}
        </Typography>
      </Stack>
      <Stack spacing={1.5}>
        {goals.map((goal) => (
          <Box key={goal.id} sx={{ p: 1.5, borderRadius: 2, backgroundColor: INTERAX_COLORS.black20 }}>
            <Typography sx={{ color: INTERAX_COLORS.white, fontSize: 14 }}>{goal.goal}</Typography>
            <Typography sx={{ color: INTERAX_COLORS.thunderGrey, fontSize: 12, mt: 0.5 }}>
              {t(GOAL_SOURCE_KEY[goal.source])}
            </Typography>
          </Box>
        ))}
      </Stack>
    </GamerFeedbackContainerBox>
  )
}

export default ProfileGoalsCard
